/**
 * Report types — report definitions, parameters, results,
 * saved queries, and schedules.
 */
/**
 * Enumeration of all available report types.
 * Grouped loosely by module.
 */
export var ReportType;
(function (ReportType) {
    // ---- Client / Person reports ----
    ReportType["ACTIVE_CLIENTS"] = "active_clients";
    ReportType["CLIENT_DEMOGRAPHICS"] = "client_demographics";
    ReportType["CLIENT_LIST"] = "client_list";
    ReportType["CLIENT_DETAIL"] = "client_detail";
    ReportType["CLIENT_HISTORY"] = "client_history";
    ReportType["CLIENT_INTAKE_SUMMARY"] = "client_intake_summary";
    ReportType["CLIENT_DEPARTURE_SUMMARY"] = "client_departure_summary";
    ReportType["CLIENT_TRANSFERS"] = "client_transfers";
    ReportType["CLIENT_BY_REFERRAL_SOURCE"] = "client_by_referral_source";
    ReportType["CLIENT_BY_COUNTY"] = "client_by_county";
    ReportType["CLIENT_BY_ZIP"] = "client_by_zip";
    ReportType["CLIENT_AGE_DISTRIBUTION"] = "client_age_distribution";
    ReportType["CLIENT_GENDER_DISTRIBUTION"] = "client_gender_distribution";
    ReportType["CLIENT_RACE_ETHNICITY"] = "client_race_ethnicity";
    ReportType["CLIENT_LANGUAGE"] = "client_language";
    ReportType["CLIENT_DISABILITY"] = "client_disability";
    ReportType["CLIENT_VETERAN"] = "client_veteran";
    ReportType["RECIDIVISM"] = "recidivism";
    ReportType["UNDUPLICATED_COUNT"] = "unduplicated_count";
    // ---- Shelter reports ----
    ReportType["BED_UTILIZATION"] = "bed_utilization";
    ReportType["BED_NIGHTS"] = "bed_nights";
    ReportType["BED_BOARD_SNAPSHOT"] = "bed_board_snapshot";
    ReportType["AVERAGE_LENGTH_OF_STAY"] = "average_length_of_stay";
    ReportType["SHELTER_CENSUS"] = "shelter_census";
    ReportType["SHELTER_OCCUPANCY_TREND"] = "shelter_occupancy_trend";
    ReportType["TURNAWAY_REPORT"] = "turnaway_report";
    ReportType["TURNAWAY_SUMMARY"] = "turnaway_summary";
    ReportType["WAITING_LIST_REPORT"] = "waiting_list_report";
    ReportType["MEAL_COUNT_REPORT"] = "meal_count_report";
    ReportType["MEAL_SUMMARY"] = "meal_summary";
    // ---- Service / Activity reports ----
    ReportType["SERVICES_PROVIDED"] = "services_provided";
    ReportType["SERVICES_BY_TYPE"] = "services_by_type";
    ReportType["SERVICES_BY_STAFF"] = "services_by_staff";
    ReportType["SERVICES_BY_SITE"] = "services_by_site";
    ReportType["SERVICES_BY_PROGRAM"] = "services_by_program";
    ReportType["SERVICES_BY_FUNDER"] = "services_by_funder";
    ReportType["SERVICE_HOURS"] = "service_hours";
    ReportType["SERVICE_UNITS"] = "service_units";
    ReportType["ACTIVITY_LOG"] = "activity_log";
    ReportType["STAFF_PRODUCTIVITY"] = "staff_productivity";
    // ---- Case management reports ----
    ReportType["CASE_NOTES_REPORT"] = "case_notes_report";
    ReportType["GOALS_REPORT"] = "goals_report";
    ReportType["OUTCOMES_REPORT"] = "outcomes_report";
    ReportType["SAFETY_PLAN_REPORT"] = "safety_plan_report";
    ReportType["DANGER_ASSESSMENT_REPORT"] = "danger_assessment_report";
    // ---- Legal reports ----
    ReportType["LEGAL_CASES_REPORT"] = "legal_cases_report";
    ReportType["PROTECTION_ORDERS_REPORT"] = "protection_orders_report";
    ReportType["PROTECTION_ORDER_EXPIRATION"] = "protection_order_expiration";
    ReportType["COURT_ADVOCACY_REPORT"] = "court_advocacy_report";
    ReportType["COURT_ADVOCACY_HOURS"] = "court_advocacy_hours";
    ReportType["ABUSER_REPORT"] = "abuser_report";
    ReportType["ABUSER_ALERT_REPORT"] = "abuser_alert_report";
    // ---- Hotline reports ----
    ReportType["HOTLINE_CALLS"] = "hotline_calls";
    ReportType["HOTLINE_CALL_VOLUME"] = "hotline_call_volume";
    ReportType["HOTLINE_BY_TIME_OF_DAY"] = "hotline_by_time_of_day";
    ReportType["HOTLINE_BY_REFERRAL"] = "hotline_by_referral";
    // ---- Outreach reports ----
    ReportType["OUTREACH_CONTACTS"] = "outreach_contacts";
    ReportType["OUTREACH_SERVICES"] = "outreach_services";
    ReportType["OUTREACH_BY_LOCATION"] = "outreach_by_location";
    // ---- Child reports ----
    ReportType["CHILDREN_SERVED"] = "children_served";
    ReportType["CHILDREN_BY_AGE"] = "children_by_age";
    ReportType["CHILDREN_SCHOOL_STATUS"] = "children_school_status";
    // ---- Federal / grant reports ----
    ReportType["VOCA_REPORT"] = "voca_report";
    ReportType["VAWA_REPORT"] = "vawa_report";
    ReportType["FVPSA_REPORT"] = "fvpsa_report";
    ReportType["HUD_APR"] = "hud_apr";
    ReportType["HMIS_EXPORT"] = "hmis_export";
    ReportType["CUSTOM_FUNDER_REPORT"] = "custom_funder_report";
    // ---- Administrative reports ----
    ReportType["USER_ACTIVITY_LOG"] = "user_activity_log";
    ReportType["AUDIT_TRAIL"] = "audit_trail";
    ReportType["DATA_QUALITY"] = "data_quality";
    ReportType["MISSING_DATA"] = "missing_data";
    ReportType["DUPLICATE_CHECK"] = "duplicate_check";
    ReportType["AGENCY_SUMMARY"] = "agency_summary";
    ReportType["PROGRAM_SUMMARY"] = "program_summary";
    ReportType["FUNDER_SUMMARY"] = "funder_summary";
})(ReportType || (ReportType = {}));
//# sourceMappingURL=reports.js.map